export type DispatcherStatus = "AVAILABLE" | "OFFDUTY" | "ONDUTY" | "DISABLED";
export type DispatcherType = "MEDIC" | "POLICE" | "FIREFIGHTER";

interface DispatcherAssignments {
  assignmentID: string;
  dispatcherID: number;
  incidentID: number;
  groupID: string;
}

export interface Dispatcher {
  dispatcherID: number;
  name: string;
  contactNumber: string;
  status: DispatcherStatus;
  dispatcherType: DispatcherType;
  assignmentID: string | null;
  DispatcherAssignments: DispatcherAssignments[];
  locationID: string;
}

export interface AddEditDispatcherData {
  name: string;
  contactNumber: string;
  dispatcherType: DispatcherType;
  locationID: string;
}

export interface DispatcherApiResponse {
  data: Dispatcher[];
  meta: {
    total: number;
    pageNo: number;
    totalPages: number;
    hasNextPage: boolean;
    perPage: string;
  };
}

export type DispatcherActionType = "delete";

export const formatDispatcherStatus = (status: DispatcherStatus): string => {
  const statusMap: Record<DispatcherStatus, string> = {
    AVAILABLE: "Available",
    OFFDUTY: "Off Duty",
    ONDUTY: "On Duty",
    DISABLED: "Disabled",
  };
  return statusMap[status] || status;
};

export const formatDispatcherType = (type: DispatcherType): string => {
  const typeMap: Record<DispatcherType, string> = {
    MEDIC: "Medic",
    POLICE: "Police",
    FIREFIGHTER: "Fire Fighter",
  };
  return typeMap[type] || type;
};
